<!-- Decorative only: the host is aria-hidden (OB-A-04). Cards are precomputed (layoutDarkEntryField). -->
<div class="vf-de-field" [class.vf-de-field--still]="still$ | async">
    <div
        *ngFor="let card of cards; trackBy: trackById"
        class="vf-de-field__card"
        [style.left.%]="card.left"
        [style.top.%]="card.top"
        [style.transform]="card.transform"
        [style.opacity]="card.opacity"
    >
        <div
            class="vf-de-field__tile"
            [style.animation-duration.s]="card.driftSeconds"
            [style.animation-delay.s]="card.driftDelaySeconds"
        >
            <span class="vf-de-field__line"></span>
            <span class="vf-de-field__line vf-de-field__line--long"></span>
        </div>
    </div>
    <div *ngIf="sweep" class="vf-de-field__sweep"></div>
</div>
